import React from 'react'

const SatScoreTables = ({
  readingWriting = {
    m1: 0,
    m2: 0,
    total: 0,
    incorrect1: 0,
    incorrect2: 0,
    incorrectTotal: 0,
    omitted1: 0,
    omitted2: 0,
    omittedTotal: 0,
  },
  math = {
    m1: 0,
    m2: 0,
    total: 0,
    incorrect1: 0,
    incorrect2: 0,
    incorrectTotal: 0,
    omitted1: 0,
    omitted2: 0,
    omittedTotal: 0,
  },
}) => {
  return (
    <div className="flex flex-wrap gap-6 w-full">
      {/* Reading & Writing Table */}
      <div className="flex-1 min-w-[320px] bg-white rounded-xl border border-[#F0F0F0] p-4">
        <div className="text-lg font-semibold mb-2">Reading & Writing</div>
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-[#F8F8F8] text-[#535862] font-semibold">
              <th className="py-2 px-4"></th>
              <th className="py-2 px-4">M1</th>
              <th className="py-2 px-4">M2</th>
              <th className="py-2 px-4">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="py-2 px-4 text-[#3BBC4C] font-medium">Correct</td>
              <td className="py-2 px-4">{readingWriting.m1}</td>
              <td className="py-2 px-4">{readingWriting.m2}</td>
              <td className="py-2 px-4">{readingWriting.total}</td>
            </tr>
            <tr>
              <td className="py-2 px-4 text-[#E90004] font-medium">
                Incorrect
              </td>
              <td className="py-2 px-4 text-[#E90004]">
                {readingWriting.incorrect1}
              </td>
              <td className="py-2 px-4 text-[#E90004]">
                {readingWriting.incorrect2}
              </td>
              <td className="py-2 px-4 text-[#E90004]">
                {readingWriting.incorrectTotal}
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 text-[#F36A3E] font-medium">Omitted</td>
              <td className="py-2 px-4 text-[#F36A3E]">
                {readingWriting.omitted1}
              </td>
              <td className="py-2 px-4 text-[#F36A3E]">
                {readingWriting.omitted2}
              </td>
              <td className="py-2 px-4 text-[#F36A3E]">
                {readingWriting.omittedTotal}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* Math Table */}
      <div className="flex-1 min-w-[320px] bg-white rounded-xl border border-[#F0F0F0] p-4">
        <div className="text-lg font-semibold mb-2">Math</div>
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-[#F8F8F8] text-[#535862] font-semibold">
              <th className="py-2 px-4"></th>
              <th className="py-2 px-4">M1</th>
              <th className="py-2 px-4">M2</th>
              <th className="py-2 px-4">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="py-2 px-4 text-[#3BBC4C] font-medium">Correct</td>
              <td className="py-2 px-4">{math.m1}</td>
              <td className="py-2 px-4">{math.m2}</td>
              <td className="py-2 px-4">{math.total}</td>
            </tr>
            <tr>
              <td className="py-2 px-4 text-[#E90004] font-medium">
                Incorrect
              </td>
              <td className="py-2 px-4 text-[#E90004]">{math.incorrect1}</td>
              <td className="py-2 px-4 text-[#E90004]">{math.incorrect2}</td>
              <td className="py-2 px-4 text-[#E90004]">
                {math.incorrectTotal}
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 text-[#F36A3E] font-medium">Omitted</td>
              <td className="py-2 px-4 text-[#F36A3E]">{math.omitted1}</td>
              <td className="py-2 px-4 text-[#F36A3E]">{math.omitted2}</td>
              <td className="py-2 px-4 text-[#F36A3E]">{math.omittedTotal}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default SatScoreTables
